<template>
    <div>
        <div class="float-right">
            <template v-if="count > 5"><span class="align-middle">Rows per page:</span>
                <div class="page rounded" v-for="p in rowOptions"
                     :class="{'bg-primary-600 text-white': p == rowsPerPage}" @click="changeRows(p)">{{ p }}
                </div>
                <div class="page">|</div>
            </template>
            <span class="align-middle" v-if="count > 0">Page: </span>
            <div class="px-2 rounded cursor-pointer inline-block align-middle" v-if="maxPage >= 1"
                 @click="$emit('update', 0, rowsPerPage)" :class="{'bg-primary-600 text-white': page == 0}">First
            </div>
            <div class="px-2 rounded cursor-pointer inline-block align-middle" v-for="p in pageOptions"
                 @click="goToPage(p)" :class="{'bg-primary-600 text-white': page == p}">{{ p + 1 }}
            </div>
            <div class="px-2 rounded cursor-pointer inline-block align-middle" v-if="maxPage >= 1" s="s"
                 @click="$emit('update', maxPage, rowsPerPage)" :class="{'bg-primary-600 text-white': page == maxPage}">
                Last
            </div>
            <div class="inline-block px-2 align-middle" v-if="count > 0">Showing {{ start }} - {{ end }} of {{
                    count
                }}
            </div>
            <div class="inline-block px-2 align-middle" v-else="count > 0">Showing 0 of 0</div>
            <div class="cursor-pointer inline-block sprite-icons-refresh align-middle" v-if="showRefresh"
                 @click="$emit('refresh')"></div>
        </div>
        <div class="clearfix"></div>
    </div>
</template>
<script>
const pageRows = [5, 10, 20, 50, 100, 200]

export default {
    props: {
        count: Number,
        page: Number,
        rowsPerPage: Number,
        showRefresh: Boolean
    },
    methods: {
        changeRows(rows) {
            // Make sure if you select a new number of rows to stay within range
            var maxPage = Math.ceil(this.count / rows) - 1
            this.$emit('update', Math.min(maxPage, this.page), rows)
        },
        goToPage(page) {
            this.$emit('update', page, this.rowsPerPage)
        }
    },
    computed: {
        pageOptions() {
            var start = Math.max(this.page - 3, 1)
            var end = Math.min(this.maxPage, start + 6)
            if (end - start > 0) {
                return new Array(end - start).fill(0).map((_, i) => i + start)
            }
            return []
        },
        rowOptions() {
            // select first index where option is more than total count
            // if there is 72 rows first hit will be 100.
            var idx = pageRows.findIndex(p => p >= this.count)
            if (idx == -1) {
                // return all
                return pageRows
            }
            return pageRows.slice(0, idx + 1)

        },
        maxPage() {
            return Math.ceil(this.count / this.rowsPerPage) - 1
        },
        start() {
            // 1 based
            return (this.page * this.rowsPerPage) + 1
        },
        end() {
            return Math.min(this.count, this.start + this.rowsPerPage - 1)
        },
    }
}
</script>

<style lang="scss" scoped>
.page {
    @apply inline-block px-2 mx-1 cursor-pointer align-middle;
}

.page:hover {
    @apply bg-white;
}
</style>

